import styles from './PriceDeleteNotice.module.css';

export const PRICE_DELETE_NOTICE_TITLE = '삭제해도 데이터는 지워지지 않습니다';
export const PRICE_DELETE_NOTICE_BODY = '삭제한 단가 행은 off 로 바뀌어 이후 비용 계산에서 빠지고, 이력은 그대로 남습니다. 이미 계산된 데이터의 삭제가 필요하면 리프레시 요청을 주셔야 합니다.';

/** 삭제(off)가 섞인 반영 요청 위에 띄우는 안내. */
export default function PriceDeleteNotice({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <section className={styles.notice} role="note" aria-label={PRICE_DELETE_NOTICE_TITLE}>
      <span className={styles.icon} aria-hidden>!</span>
      <div>
        <h3>{PRICE_DELETE_NOTICE_TITLE}<span className={styles.count}>삭제 {count}건</span></h3>
        <p>{PRICE_DELETE_NOTICE_BODY}</p>
      </div>
    </section>
  );
}
